import { Card } from '@mui/material';
import { useMaterialUIController } from 'context';
import React from 'react';


function ViewCard({children, ...props }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (<Card sx={props.sx}  style={darkMode ?{ backgroundColor: "#202940" }: { backgroundColor: "aliceblue" }} className={props.className}>
{children}
  </Card>)
}

export default ViewCard;